import { createAsyncThunk } from '@reduxjs/toolkit';
import Api from '../../api';

export const checkOutRequest = createAsyncThunk('checkOutAction/checkOutRequest', async (payload, thunkAPI) => {
  try {
    const { data } = await Api.checkOut(payload);
    return data;
  } catch (e) {
    return thunkAPI.rejectWithValue(e.response.data);
  }
});
